import * as React from 'react';
import { IProgramWithPaymentCalculation } from '../../../../../../types/mortgage';
import { UIText1, UIText2 } from '@cian/ui-kit';
import { clsx } from 'clsx';
import * as styles from './ProgramRow.css';
import { numberToPrettyString } from '@cian/utils';
import { programIcons } from '../../../../assets';
import { MORTGAGE_LINK } from '../../../../../../constants/mortgage';

interface IProgramRowProps extends IProgramWithPaymentCalculation {
  onProgramClick(): void;
  onLabelClick(event: React.MouseEvent<HTMLAnchorElement>): void;
}

export const ProgramRow: React.FC<IProgramRowProps> = ({
  id,
  name,
  shortDescription,
  rate,
  creditLimitMillions,
  termYears,
  payment,
  onProgramClick,
  onLabelClick,
}) => {
  return (
    <div className={styles['row']} onClick={onProgramClick}>
      <div className={clsx(styles['info-cell'])}>
        <img className={styles['icon']} src={programIcons[id]} />
        <div className={styles['info']}>
          <div className={styles['name']}>
            <UIText1>{name}</UIText1>
          </div>
          {shortDescription && <UIText2 color="gray60_100">{shortDescription}</UIText2>}
        </div>
      </div>
      <UIText1>{rate}%</UIText1>
      <UIText1>до {creditLimitMillions} млн ₽</UIText1>
      <UIText1>до {termYears} лет</UIText1>
      <div className={styles['payment']}>
        <UIText1 textAlign="right">{numberToPrettyString(payment)} ₽/мес</UIText1>
        <a
          className={styles['online-label']}
          href={MORTGAGE_LINK}
          onClick={onLabelClick}
          target="_blank"
          rel="noreferrer"
        >
          Получить онлайн
        </a>
      </div>
    </div>
  );
};
